
import {SectionBgView} from '../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {UIGameStateController} from '../../../shared/scripts/ui_game/UIGameStateController'
import {PIXI} from '@colonist/pixi'
import {TranslationObject} from '@colonist/i18n'
import {TextTruncatedView} from '../../../shared/scripts/ui_canvas_engine/TextTruncatedView'
import {UIGameSpriteHandler} from '../../../shared/scripts/UIGameSpriteHandler'
import {Sprites} from '../../../shared/scripts/ui_game/UIGameImageDictionary'
import {UIGamePlayerAvatarView} from '../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerAvatarView'
import {SpriteView} from '../../../shared/scripts/ui_canvas_engine/SpriteView'

export class UIWGameStateController extends UIGameStateController {
    protected createContainer() {
        const canvas = this.uiGameManager.canvasController
        const x = canvas.appW - canvas.chatWidth - canvas.itemSize * (this.uiGameManager.gameController.isReplay ? 3 : 4)
        const y = canvas.appH - canvas.itemSize * 1.5
        const w = canvas.itemSize * 3
        const h = canvas.itemSize / 2
        this.container = new SectionBgView(x, y, w, h, canvas.app.stage)
        this.container.drawRoundedBg()
        this.container.interactive = true
        this.container.on('pointerover', (e: PIXI.FederatedEvent) => {
            e.stopPropagation()
        })
        this.createPlayerAvatar()
        this.createStateText()
    }

    private createPlayerAvatar() {
        const currentTurnPlayerState = this.uiGameManager.gameController.getPlayerState(this.uiGameManager.gameController.currentState.currentTurnPlayerColor)
        this.singlePlayerAvatar = new UIGamePlayerAvatarView(0, 0, this.container.height, this.container, currentTurnPlayerState)
        this.singlePlayerAvatar.updatePlayerIcon(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_bot))

        this.multiPlayerIcon = new SpriteView(0, 0, this.container.height, this.container.height, this.container, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_players))
    }

    private createStateText() {
        const placeHolderText: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
        const stateTextX = this.singlePlayerAvatar.x + this.singlePlayerAvatar.width
        const stateTextW = this.container.width - stateTextX
        this.stateText = new TextTruncatedView(placeHolderText, stateTextX, 0, stateTextW, this.container.height, this.container)
    }
}
